module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {   
        var hostnameArray = window.location.hostname.split('.');
        var subDomain = hostnameArray[0].substring(1);
        var currentConfig = subDomain == "ww"? "":"test";   
        return new Service({
            name: 'challengeDisplayInfo',
            group: "eprsvc",
            cache :false,
            url: "https://login"+currentConfig+".highmark.com/oam/services/rest/auth/api/v1/mfa/challengeDisplayInfo",
            enrollCheck: function(userId) {
             this.headers= {pragma :undefined,
                "cache-control":undefined,"If-Modified-Since":undefined
            };
               this.withCredentials = false; 
             
               this.url = 'https://login'+currentConfig+'.highmark.com/oam/services/rest/auth/api/v1/mfa/challengeDisplayInfo?appName=test&userId='+userId;
               return this.get();
                // return this.get({
                //     appName: "test",
                //     userId: userId
                // }
                //);
            }
        });
    }]);
};
